export function paramsMap(params): any {
  return Object.keys(params).reduce((parsedObj, item) => {
    return {
      ...parsedObj,
      [item.replace('amp;', '')]: params[item]
    };
  }, {});
}
